import React, { useEffect, useState } from "react";
import GatewayService from "../service/GatewayService";
import { ClientBalance } from "../models/ClientMargin";

const MarginsComponent = () => {
  const [margins, setMargins] = useState<ClientBalance[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMargins = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await GatewayService.getAllClientBalance();
      setMargins(data);
    } catch (e: any) {
      setError(e.message || "Failed to fetch margins");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMargins();
  }, []);

  return (
    <div>
      <h2 style={{ fontSize: 16, marginBottom: 8 }}>Margins</h2>
      <button style={{ fontSize: 12, padding: '2px 10px', marginBottom: 6 }} onClick={fetchMargins} disabled={loading}>
        {loading ? "Refreshing..." : "Refresh"}
      </button>
      {error && <div style={{ color: "red", fontSize: 12 }}>{error}</div>}
      <table className="margins-table">
        <thead>
          <tr>
            <th>Client ID</th>
            <th>Margin</th>
            <th>Available Cash</th>
            <th>Wallet Balance</th>
            <th>Margin Utilized</th>
            <th>Cash Margin</th>
            <th>Total Margin</th>
          </tr>
        </thead>
        <tbody>
          {margins.map((m) => (
            <tr key={m.clientId}>
              <td>{m.clientId}</td>
              <td>{(m.balance.available_margin / 100000).toFixed(2)} L</td>
              <td>{(m.balance.live_balance / 100000).toFixed(2)} L</td>
              <td>{(m.balance.wallet_balance / 100000).toFixed(2)} L</td>
              <td>{(m.balance.marginUsed / 100000).toFixed(2)} L</td>
              <td>{(m.balance.cashMargin / 100000).toFixed(2)} L</td>
              <td>{(m.balance.totalMargin / 100000).toFixed(2)} L</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MarginsComponent; 